import React from "react";

const CityReg = ({ cityReg }) => {
    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th className="px-3">Band Name</th>
                        <th className="px-3">City</th>
                        <th className="px-3">Email Id</th>
                        <th className="px-3">Genre</th>
                        <th className="px-3">No of Members</th>
                        <th className="px-3">Band Members</th>
                        <th className="px-3">Original Compositions</th>
                        <th className="px-3">Past Achievements</th>
                    </tr>
                </thead>
                <tbody>
                    {cityReg.map((element) => {
                        console.log(element);
                        return (
                            <tr>
                                <td className="px-3">{element.band_name}</td>
                                <td className="px-3">{element.city}</td>
                                <td className="px-3">{element.emailid}</td>
                                <td className="px-3">{element.genre}</td>
                                <td className="px-3">
                                    {element.no_of_members}
                                </td>
                                <td className="px-3">{element.bandmembers}</td>
                                <td className="px-3">
                                    {element.original_composition}
                                </td>
                                <td className="px-3">
                                    {element.past_achievments}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <hr />
        </>
    );
};

export default CityReg;
